import {SERVER_API_FB_BOT} from '../../constans/index';
import {
    UPDATE_MULTI_CONVERSATION_REQUEST,
    UPDATE_MULTI_CONVERSATION_SUCCESS,
    UPDATE_MULTI_CONVERSATION_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const UpdateMultiConversationAction = (dataTarget) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_FB_BOT}/api/conversations`;
        },
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(dataTarget);
        }),
        types: [
            UPDATE_MULTI_CONVERSATION_REQUEST,
            {
                type: UPDATE_MULTI_CONVERSATION_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": UPDATE_MULTI_CONVERSATION_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: UPDATE_MULTI_CONVERSATION_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": UPDATE_MULTI_CONVERSATION_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {UpdateMultiConversationAction}